import * as React from 'react';
import style from './WTableFieldGroup.less';
import { WTable } from './WTable';
import { runInThisContext } from 'vm';

interface WTableFieldGroupProps extends React.ClassAttributes<any> {
    columns: Array<any>;
    posX: number;
    posY: number;
    cfgData?: Array<any>;
    preCfg?: any;
    onChange: (columns: Array<any>, cfgData: Array<any>) => void;
    onMouseLeave: () => void;
}

interface WTableFieldGroupState {
    cfgData: Array<any>;
}

export class WTableFieldGroup extends React.Component<WTableFieldGroupProps, WTableFieldGroupState>  {
    constructor(props: any) {
        super(props);

        let cfgData: Array<any> = [];
        if (Array.isArray(this.props.cfgData)) {
            cfgData = this.props.cfgData;
        } else {
            const groups = this.getFieldGroups();
            const gKeys = Object.keys(groups);
            gKeys.map((name: string) => {
                let member = groups[name].items.map((g: any) => { return g.HeaderText; }).sort().join(', ');
                if (member.length > 150) {
                    member = <div>
                        {member.substr(0, 130) + ' ...'}
                        <div style={{ fontStyle: 'italic', color: 'gray' }}>{'(insgesamt ' + groups[name].items.length + ')'}</div>
                    </div>;
                }
                cfgData.push({
                    name: name,
                    member: member,
                    items: groups[name].items,
                    hidden: groups[name].hidden
                });
            });
        }

        this.state = {
            cfgData
        };

        this.onChange = this.onChange.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.getFieldGroups = this.getFieldGroups.bind(this);
    }

    getFieldGroups() {
        const preCfgHidden = this.props.preCfg && typeof this.props.preCfg.hidden === 'object' ? this.props.preCfg.hidden : {};
        const groups: any = {};
        this.props.columns.map((r: any) => {
            if (typeof r.field_group === 'string' && r.field_group !== '') {
                const g = r.field_group;
                if (groups[g] === undefined) {
                    groups[g] = {
                        hidden: typeof preCfgHidden[g] === 'boolean' ? preCfgHidden[g] : false,
                        items: []
                    };
                }
                groups[g].items.push(r);
            }
        });
        return groups;
    }

    onChange() {
        const columns = this.props.columns;
        const cfgData = this.state.cfgData;
        cfgData.map((g: any) => {
            columns.map((r: any) => {
                if (r.show_orig !== false && typeof r.field_group === 'string' && r.field_group === g.name) {
                    r.show = !g.hidden;
                }
            });
        });
        this.props.onChange(columns, cfgData);
    }

    onToggle() {
        const cfgData = this.state.cfgData;
        const found = cfgData.find((r: any) => { return r.hidden === false; });
        let toggleValue = false;
        if (found) {
            toggleValue = true;
        }
        cfgData.map((r: any) => {
            r.hidden = toggleValue;
        });
        this.setState({ cfgData }, this.onChange);
    }

    render(): JSX.Element {
        return (
            <div
                className={style.floatbox}
                style={{ top: this.props.posY.toString() + 'px', left: this.props.posX.toString() + 'px' }}
                onMouseLeave={this.props.onMouseLeave}
            >
                <div className={style.listContainer}>
                    {this.state.cfgData.map((r: any, idx: number) => {
                        return (
                            <div
                                className={style.row}
                                onClick={() => {
                                    const data = this.state.cfgData;
                                    data[idx].hidden = !data[idx].hidden;
                                    this.setState({ cfgData: data }, this.onChange);
                                }}
                            >
                                <div className={style.cell1}>{r.name}</div>
                                <div className={style.cell3}>
                                    <input
                                        style={{ verticalAlign: 'bottom' }}
                                        type='checkbox'
                                        checked={r.hidden === true ? false : true}
                                    />
                                </div>
                                <div className={style.cell2}>{r.member}</div>
                            </div>
                        );
                    })}
                </div>
                <div style={{ textAlign: 'right' }}>
                    <button
                        style={{ fontSize: '12px' }}
                        onClick={this.onToggle}
                    >
                        Alles ein/ausblenden
                    </button>
                </div>
            </div>
        );
    }
}
